import { useState } from 'react';
import { Project } from '@vault/shared';
import Sidebar from './Sidebar';
import ProjectView from './ProjectView';
import { useProjects } from '../hooks/useProjects';

export default function Dashboard() {
  const [selectedProject, setSelectedProject] = useState<Project | null>(null);
  const { projects, loading, createProject, updateProject, deleteProject } = useProjects();

  return (
    <div className="flex gap-6 h-[calc(100vh-8rem)]">
      {/* Sidebar */}
      <div className="w-80 flex-shrink-0">
        <Sidebar
          projects={projects}
          selectedProject={selectedProject}
          onSelectProject={setSelectedProject}
          onCreateProject={createProject}
          onUpdateProject={updateProject}
          onDeleteProject={deleteProject}
          loading={loading}
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 min-w-0">
        {selectedProject ? (
          <ProjectView project={selectedProject} />
        ) : (
          <div className="card h-full flex items-center justify-center">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Select a project
              </h3>
              <p className="text-gray-500">
                Choose a project from the sidebar to view and manage its environment variables.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}